import heading from '../../components/Heading';
import input from '../../components/Input';
import linkRow from '../../components/LinkRow';
import screenLink from '../../components/ScreenLink';
import socialButton from '../../components/SocialButton';
import submitButton from '../../components/SubmitButton';
import validation from '../../components/Validation';

import loginTemplate from './loginTemplate.ejs';
import styles from './styles.less';

export default (data: any) => loginTemplate({
    ...data,
    heading,
    input,
    linkRow,
    screenLink,
    socialButton,
    styles,
    submitButton,
    validation,
});
